<template>

  <section class="section">
    <div class="container-lg flex flex-row gap-[64px]">

      <div class="flex flex-col">
        <div class="flex flex-col pb-[44px]">
          <h1 class="mt-0 mb-[24px]  ">
            {{ splitTitle.first }}
            <span :class="['text-lime-green ']">
              {{ splitTitle.last }}
            </span>
          </h1>

          <div class="flex gap-[16px] bg-white border border-charcoal/[7%] p-[24px] rounded-[12px] shadow-base">

            <div class="flex items-center justify-center bg-gray w-full max-w-[44px] max-h-[44px] rounded-full">
              <svg class="w-[20px] h-[20px]" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.0007 10.0003C12.3018 10.0003 14.1673 8.13485 14.1673 5.83366C14.1673 3.53247 12.3018 1.66699 10.0007 1.66699C7.69946 1.66699 5.83398 3.53247 5.83398 5.83366C5.83398 8.13485 7.69946 10.0003 10.0007 10.0003Z"
                    stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M17.1585 18.3333C17.1585 15.1083 13.9501 12.5 10.0001 12.5C6.05013 12.5 2.8418 15.1083 2.8418 18.3333"
                    stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="flex flex-col gap-1">
              <span>
                {{ in18['page_authorize_text'] }}
              </span>
              <a class="link  link--primary w-max" href="/register">
                {{ in18['page_authorize_link'] }}
              </a>
            </div>
          </div>
        </div>

        <div class="lg:hidden h-max w-full pb-[44px]">
          <checkout-summary
              :cart="cart"
              :in-progress="inProgress"
              :in18="in18"
              @process-checkout="processCheckout"
          />
          <cart-coupon
              :cart="cart"
              :in-progress="inProgress"
              :in18="in18"
              @update-cart="updateCart"
              @update-in-progress="updateInProgress"
          />
        </div>

        <div class="w-full">

          <form class="" @submit.prevent="processCheckout">
            <div class="form__fieldset">

              <h3 class="text-[20px] mt-0 mb-[24px]">
                {{ in18['page_contact_info'] }}
              </h3>

              <div v-if="!is_auth" class="form__group--md  form__group--flex">
                <div class="radio">
                  <input
                      id="type_b2c"
                      v-model="order.user_type"
                      :disabled="inProgress"
                      class="radio__input"
                      name="type"
                      type="radio"
                      value="b2c"
                  >
                  <label class="radio__label" for="type_b2c">
                    {{ in18['attribute_type_individual'] }}
                  </label>
                </div>
                <div class="radio">
                  <input
                      id="type_b2b"
                      v-model="order.user_type"
                      :disabled="inProgress"
                      class="radio__input"
                      name="type"
                      type="radio"
                      value="b2b"
                  >
                  <label class="radio__label" for="type_b2b">
                    {{ in18['attribute_type_legal'] }}
                  </label>
                </div>
                <validation-error :errors="errors['order.user_type']"/>
              </div><!-- user_type -->

              <div v-if="(order.user_type === 'b2b' || order.user_type === 'b2g') && !is_auth" class="row mb-4">
                <div class="col-lg-12">
                  <div class="info-text border border-lime-green-hover mb-4" v-html="auth_b2b_message"/>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                <div class="flex flex-col gap-1 relative">
                  <label
                      :class="[order.user_name ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                      class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                      for="user_name">
                    {{ in18['attribute_user_name'] }}
                  </label>
                  <input
                      id="user_name"
                      v-model="order.user_name"
                      :class="[errors['order.user_name'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', order.user_name && 'pt-[30px]' ]"
                      :disabled="inProgress"
                      class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none transition-all"
                      name="user_name"
                      type="text"
                      @input="clearValidationError('order.user_name')"
                  >
                  <span v-if="errors['order.user_name']?.length"
                        class="!text-[12px] text-[#eb2635]">*{{ errors['order.user_name']?.[0] }}</span>
                </div>

                <div class="flex flex-col gap-1 relative">
                  <label
                      :class="[order.user_surname ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                      class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                      for="user_surname">
                    {{ in18['attribute_user_surname'] }}
                  </label>
                  <input
                      id="user_surname"
                      v-model="order.user_surname"
                      :class="[errors['order.user_surname'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', order.user_surname && 'pt-[30px]' ]"
                      :disabled="inProgress"
                      class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none focus-within:border-lime-green transition-all"
                      name="user_surname"
                      type="text"
                      @input="clearValidationError('order.user_surname')"
                  >
                  <span v-if="errors['order.user_surname']?.length"
                        class="!text-[12px] text-[#eb2635]">*{{ errors['order.user_surname']?.[0] }}</span>
                </div>


                <div class="flex flex-col gap-1 relative">
                  <label
                      :class="[order.user_email ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                      class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                      for="user_email">
                    {{ in18['attribute_user_email'] }}
                  </label>
                  <input
                      id="user_email"
                      v-model="order.user_email"
                      :class="[errors['order.user_email'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', order.user_email && 'pt-[30px]' ]"
                      :disabled="inProgress"
                      class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none focus-within:border-lime-green transition-all"
                      name="user_email"
                      type="text"
                      @input="clearValidationError('order.user_email')"
                  >
                  <span v-if="errors['order.user_email']?.length"
                        class="!text-[12px] text-[#eb2635]">*{{ errors['order.user_email']?.[0] }}</span>
                </div>

                <div class="flex flex-col gap-1 relative overflow-hidden">
                  <label :class="[order.user_phone_number.number ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                         class=" leading-[14px] font-light absolute left-[17px] transition-all pointer-events-none"
                         for="user_phone_number">
                    {{ in18['attribute_user_phone'] }}
                  </label>

                  <input
                      id="user_phone_number"
                      v-model="order.user_phone_number.number"
                      :class="[errors['order.user_phone_number.number'] || errors['order.user_phone_number.countryCallingCode'] ? 'border-[#eb2635] ' : 'focus-within:border-lime-green border-light-gray/25', order.user_phone_number.number ? 'pl-[100px] pt-[30px]' : 'pl-[16px]' ]"
                      :disabled="inProgress"
                      class="h-[52px] text-[16px] p-[16px]   font-light leading-[20px] text-charcoal border rounded-[8px] outline-none focus-within:border-lime-green transition-all"
                      name="mobile_phone_number"
                      type="number"
                      @input="clearValidationError('order.user_phone_number.number')"
                  >
                  <div
                      :class="[order.user_phone_number.number ? 'top-[23px] left-[16px] opacity-100': 'top-[-4px] left-[-60px] opacity-0 pointer-events-none']"
                      class="absolute  text-[16px] font-thin leading-[20px] pr-2 border-r border-l-medium-gray transition-all">

                    <span class="prefix">+</span>

                    <select id="" v-model="order.user_phone_number.countryCallingCode"
                            class="appearance-none outline-none bg-opacity-0 w-[60px]"
                            name="user_phone_country"
                            v-bind:preventFocusShift="true" @update="clearValidationError('order.user_phone_number.countryCallingCode')">
                      <option v-for="c in getEUPhoneCountries()" :value="c.countryCallingCode" class="text-[14px]">
                        {{ c.countryCallingCode }}
                      </option>
                    </select>
                  </div>

                  <span v-if="phoneErrors?.length" class=" text-[12px] text-[#eb2635]">*{{ phoneErrors?.[0] }}</span>
                </div>

                <template v-if="order.user_type === 'b2b' || order.user_type === 'b2g'">

                  <div class="flex flex-col gap-1 relative">
                    <label
                        :class="[order.company_name ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                        class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                        for="company_name">
                      {{ in18['attribute_company_name'] }}
                    </label>
                    <input
                        id="company_name"
                        v-model="order.company_name"
                        :class="[errors['order.company_name'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', order.company_name && 'pt-[30px]' ]"
                        :disabled="inProgress"
                        class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none focus-within:border-lime-green transition-all"
                        name="company_name"
                        type="text"
                        @input="clearValidationError('order.company_name')"
                    >
                    <span v-if="errors['order.company_name']?.length"
                          class="!text-[12px] text-[#eb2635]">*{{ errors['order.company_name']?.[0] }}</span>
                  </div>

                  <div class="flex flex-col gap-1 relative">
                    <label
                        :class="[order.company_reg_num ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                        class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                        for="company_reg_num">
                      {{ in18['attribute_company_reg_number'] }}
                    </label>
                    <input
                        id="company_reg_num"
                        v-model="order.company_reg_num"
                        :class="[errors['order.company_reg_num'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', order.company_reg_num && 'pt-[30px]' ]"
                        :disabled="inProgress"
                        class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none focus-within:border-lime-green transition-all"
                        name="company_reg_num"
                        type="text"
                        @input="clearValidationError('order.company_reg_num')"
                    >
                    <span v-if="errors['order.company_reg_num']?.length"
                          class="!text-[12px] text-[#eb2635]">*{{ errors['order.company_reg_num']?.[0] }}</span>
                  </div>

                  <div class="flex flex-col gap-1 relative">
                    <label
                        :class="[order.company_vat_num ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
                        class=" leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
                        for="company_vat_num">
                      {{ in18['attribute_company_tax_number'] }}
                    </label>
                    <input
                        id="company_vat_num"
                        v-model="order.company_vat_num"
                        :class="[errors['order.company_vat_num'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', order.company_vat_num && 'pt-[30px]' ]"
                        :disabled="inProgress"
                        class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border  rounded-[8px] outline-none focus-within:border-lime-green transition-all"
                        name="company_vat_num"
                        type="text"
                        @input="clearValidationError('order.company_vat_num')"
                    >
                    <span v-if="errors['order.company_vat_num']?.length"
                          class="!text-[12px] text-[#eb2635]">*{{ errors['order.company_vat_num']?.[0] }}</span>
                  </div>
                </template>
              </div><!-- /.row -->
            </div><!-- /.form__fieldset -->

            <checkout-shipping
                :addresses="addresses"
                :cart="cart"
                :errors="errors"
                :in-progress="inProgress"
                :in18="in18"
                :shipping="shipping"
                @update-error="updateError"
                @update-cart="updateCart"
                @update-shipping-method="updateShippingMethod"
                @update-in-progress="updateInProgress"
                @update-shipping-address="updateShippingAddress"
            /><!-- /.form__fieldset -->

            <checkout-payment
                v-if="selectedShippingMethod !== null"
                :cart="cart"
                :errors="errors"
                :in-progress="inProgress"
                :in18="in18"
                :selected-shipping-method="selectedShippingMethod"
                @update-cart="updateCart"
                @update-payment-method="updatePaymentMethod"
                @update-in-progress="updateInProgress"
            /><!-- /.form__fieldset -->

            <div class="flex w-full gap-[16px] mb-[24px] px-4 md:px-0">
              <div class="inline-flex items-center">
                <label class="flex items-center cursor-pointer relative">
                  <input id="terms" v-model="terms" :disabled="inProgress" checked
                         class="peer h-7 w-7 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-lime-green checked:border-lime-green"
                         type="checkbox"/>
                  <span
                      class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                  <svg class="h-3.5 w-3.5" fill="currentColor" stroke="currentColor" stroke-width="1"
                       viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          fill-rule="evenodd"></path>
                  </svg>
                  </span>
                </label>
              </div>

              <div class="form__text">
                <p>
                  {{ in18['page_terms_accept'] }}
                  <a :href="terms_of_purchase_link" :title="in18['page_terms_of_purchase_title']"
                     class="link  link--primary  fw-500">
                    {{ in18['page_terms_of_purchase_title'] }}
                  </a>
                  {{ in18['page_and'] }}
                  <a :href="privacy_policy_link" :title="in18['page_privacy_policy_title']"
                     class="link  link--primary  fw-500">
                    {{ in18['page_privacy_policy_title'] }}
                  </a>
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form__group  form__group--md">
                  <button :disabled="inProgress || !terms" class="btn  btn--block  btn--green  btn--md" type="submit">
                    {{ in18['page_process_order_btn'] }} ({{ cart.formatted_total_price_with_tax }})
                  </button>
                </div>
              </div>
            </div><!-- /.row -->
          </form>
        </div>
      </div>

      <div class="hidden lg:block w-[33%] ">
        <div class="h-max w-full sticky top-[181px] flex flex-col lg:gap-y-[24px] ">
          <checkout-summary
              :cart="cart"
              :in-progress="inProgress"
              :in18="in18"
              @process-checkout="processCheckout"
          />
          <cart-coupon
              :cart="cart"
              :in-progress="inProgress"
              :in18="in18"
              @update-cart="updateCart"
              @update-in-progress="updateInProgress"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from 'vue';
import {getEUPhoneCountries} from '../helpers/phone-countries';
import axios from 'axios';
import ValidationError from '../features/ValidationError.vue';
import CartCoupon from '../components/cart/CartCoupon.vue';
import CheckoutSummary from '../components/checkout/CheckoutSummary.vue';
import CheckoutShipping from "../components/checkout/CheckoutShipping.vue";
import CheckoutPayment from "../components/checkout/CheckoutPayment.vue";

const props = defineProps({
  is_auth:                {
    type:    Number,
    default: false,
  },
  in18:                   {
    type: Object
  },
  terms_of_purchase_link: {
    type:    String,
    default: '',
  },
  privacy_policy_link:    {
    type:    String,
    default: '',
  },
  auth_b2b_message:       {
    type:    String,
    default: '',
  },
});

const addresses = ref([]);
const cart = reactive({});
const errors = reactive({});
const inProgress = ref(true);
const selectedShippingMethod = ref(null);
const selectedPaymentMethod = ref(null);
const terms = ref(false);
const shipping = reactive({
  identifier:        null,
  country_id:        112,
  region_id:         null,
  area_id:           null,
  city:              '',
  village:           '',
  building_num:      '',
  house_num:         '',
  address:           '',
  zip:               '',
  user_phone_number: {
    countryCallingCode: 371,
    number:             null
  },
  message:           '',
});

const order = reactive({
  user_type:          'b2c',
  user_name:          '',
  user_surname:       '',
  user_email:         '',
  user_phone_number:  {
    countryCallingCode: 371,
    number:             null
  },
  company_name:       '',
  company_reg_num:    '',
  company_vat_num:    '',
  company_address:    '',
  company_city:       '',
  company_zip:        '',
  company_country_id: 112,
});

const splitTitle = (string) => {
  if (!string) return {};
  const words = string.split(" ");
  const last = words.pop();
  return {
    first: words.join(" "),
    last,
  };
};

const phoneErrors = computed(() => {
  let errs = [];
  if (errors['order.user_phone_number.number']) {
    errs = errs.concat(errors['order.user_phone_number.number']);
  }
  if (errors['order.user_phone_number.countryCallingCode']) {
    errs = errs.concat(errors['order.user_phone_number.countryCallingCode']);
  }
  return errs;
});

function updateError(key, data) {
  errors[key] = data;
}

function updateCart(newCart) {
  Object.assign(cart, newCart);
}

function updateInProgress(progress) {
  if (progress === false) {
    setTimeout(() => {
      inProgress.value = false;
    }, 1000);
  } else {
    inProgress.value = progress;
  }
}

function updatePaymentMethod(paymentMethod) {
  Object.keys(errors).forEach(key => delete errors[key]);
  clearValidationError('payment_method');
  selectedPaymentMethod.value = paymentMethod;
  cart.payment_method = paymentMethod;
  inProgress.value = false;
}

function updateShippingMethod(shippingMethod) {
  Object.keys(errors).forEach(key => delete errors[key]);
  selectedShippingMethod.value = shippingMethod;
  selectedPaymentMethod.value = null;

  shipping.identifier = null;
  shipping.country = 112;
  shipping.region_id = null;
  shipping.area_id = null;
  shipping.city = '';
  shipping.village = '';
  shipping.building_num = '';
  shipping.house_num = '';
  shipping.address = '';
  shipping.zip = '';

}

function updateShippingAddress(address) {
  // console.log('updateShippingAddress');
  // console.log(address);
  shipping.identifier = address.id;
  shipping.country = address.country?.id ?? 112;
  shipping.region_id = null;
  shipping.area_id = null;
  shipping.city = address.city;
  shipping.village = '';
  shipping.building_num = '';
  shipping.house_num = '';
  shipping.address = address.address;
  shipping.zip = address.zip;
}

async function getCart() {
  const response = await axios.get('/api/cart');
  let cartData = response.data.cart;

  ga_begin_checkout_event(response.data.cart);

  Object.assign(cart, cartData);
  selectedShippingMethod.value = cartData.shipping_method ? cartData.shipping_method : null;
  selectedPaymentMethod.value = cartData.payment_method ? cartData.payment_method : null;

  shipping.identifier = cartData.shipping_address?.identifier ?? null;
  shipping.region_id = cartData.shipping_address?.region_id ?? null;
  shipping.area_id = cartData.shipping_address?.area_id ?? null;
  shipping.city = cartData.shipping_address?.city ?? '';
  shipping.village = cartData.shipping_address?.village ?? '';
  shipping.building_num = cartData.shipping_address?.building_num ?? '';
  shipping.house_num = cartData.shipping_address?.house_num ?? '';
  shipping.address = cartData.shipping_address?.address ?? '';
  shipping.zip = cartData.shipping_address?.zip ?? '';
  shipping.message = cartData.shipping_address?.message ?? '';
  return response;
}

async function getUser() {
  const response = await axios.get('/api/user');
  let user = response.data.user;

  if (!user) {
    return response;
  }

  order.user_type = user.type;
  order.user_name = user.name;
  order.user_surname = user.surname;
  order.user_email = user.email;
  order.user_phone_number = user.phone;

  if (user.type === 'b2b' || user.type === 'b2g') {
    order.company_name = user.company.name;
    order.company_reg_num = user.company.reg_num;
    order.company_vat_num = user.company.vat_num;
    order.company_address = user.company.address;
    order.company_city = user.company.city;
    order.company_zip = user.company.zip;
    order.company_country_id = user.company.country ? user.company.country.id : 112;
  }

  addresses.value = user.addresses || [];

  return response;
}

function clearValidationError(fieldName) {
  if (errors[fieldName]) {
    errors[fieldName] = null;
  }
}

function processCheckout() {
  if (inProgress.value) {
    return;
  }

  inProgress.value = true;

  let data = {
    'order':           order,
    'shipping':        shipping,
    'shipping_method': selectedShippingMethod.value?.code,
    'payment_method':  selectedPaymentMethod.value?.code,
  };

  axios.post('/api/order/store', data)
      .then((response) => {
        // console.log(response);
        ga_purchase_event(response.data.order);
        window.location.href = response.data.payment_link;
      })
      .catch((error) => {
        console.log(error);
        window.toastr.error(error.response.data.message);
        Object.assign(errors, error.response.data.errors);
        window.scrollToErrorMessage();
        inProgress.value = false;
      });
}

onMounted(async () => {
  const [cartResponse, userResponse] = await Promise.all([getCart(),
    getUser()]);
  shipping.user_phone_number = cartResponse?.shipping_address?.phone
      ? cartResponse.shipping_address.phone
      : Object.assign({
        countryCallingCode: 371,
        number:             null
      }, userResponse?.data?.user?.phone);
  inProgress.value = false;
});
</script>

<style>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide number input spinner for Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

